import React, { Fragment, useState } from "react";
import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import ruLocale from "date-fns/locale/ru";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn'

const YearMonthPicker = props => {
  //const [selectedDate, handleDateChange] = useState(new Date());
  const localeFormatMap = {
    en: "MMMM d, yyyy",
    fr: "d MMM yyyy",
    ru: "MMMM yyyy",
  };
  const localeCancelLabelMap = {
    en: "cancel",
    fr: "annuler",
    ru: "отмена",
  };
  const monthValues = {
    narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
    abbreviated: [
      "янв.",
      "фев.",
      "март",
      "апр.",
      "май",
      "июнь",
      "июль",
      "авг.",
      "сент.",
      "окт.",
      "нояб.",
      "дек."
    ],
    wide: [
      "январь",
      "февраль",
      "март",
      "апрель",
      "май",
      "июнь",
      "июль",
      "август",
      "сентябрь",
      "октябрь",
      "ноябрь",
      "декабрь"
    ]
  };
  ruLocale.localize.month = buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    defaultFormattingWidth: 'wide'
  })
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
      <DatePicker
        views={["month","year"]}
        label="Год и месяц"
        helperText=""
        minDate={new Date("2020-01-01")}
        maxDate={new Date("2031-06-01")}
        format={localeFormatMap["ru"]}
        cancelLabel={localeCancelLabelMap["ru"]}
        value={props.selectedDate}
        onChange={props.handleDateChange}
      />
    </MuiPickersUtilsProvider>      
  );
}

export default YearMonthPicker;